// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3-I09","footer":"ModalInfo_footer__2ZeKj"};